<div class="login-enter-pii-ctr">
    <app-login-enter-pii-answer 
        *ngFor="let formGroup of formArray.controls"
        [formGroup]="formGroup">
    </app-login-enter-pii-answer>
</div>